import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Space, Typography } from 'antd'
import { gql, useMutation } from '@apollo/client'

const COMPLETE_ORDER = gql`
  mutation CompleteOrder($orderId: ID!) {
    completeOrder(orderId: $orderId) {
      errors
    }
  }
`

const CompleteButton = ({ orderId, onSuccess }) => {
  const [errors, setErrors] = useState([])
  const [completeOrder, { loading }] = useMutation(COMPLETE_ORDER, {
    onCompleted: ({ completeOrder }) => {
      const errors = JSON.parse(completeOrder.errors) || []
      if (errors.length > 0) {
        setErrors(errors)
      } else {
        setErrors([])
        onSuccess()
      }
    }
  })

  const handleClick = () => {
    completeOrder({ variables: { orderId } })
  }

  return (
    <Space direction="vertical">
      <Button onClick={handleClick} type="primary" disabled={loading}>1688</Button>

      {errors.map((error, index) => (
        <Typography.Text key={index} type="danger">{error}</Typography.Text>
      ))}
    </Space>

  )
}

const UndoButton = ({ undo, onUndo }) => {
  if (!undo) return null

  return (
    <Button onClick={onUndo} type="primary" ghost>undo</Button>
  )
}

const CompleteOrderButton = ({
  orderId,
  state,
  onSuccess,
  undo,
  onUndo
}) => {
  switch (state) {
    case 'payment':
      return <CompleteButton orderId={orderId} onSuccess={onSuccess} />
    case 'complete':
      return <UndoButton undo={undo} onUndo={onUndo} />

    default:
      return 'ไม่สามารถ 1688 ได้'
  }
}

CompleteOrderButton.propTypes = {
  orderId: PropTypes.string.isRequired,
  state: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  undo: PropTypes.bool,
  onUndo: PropTypes.func.isRequired
}

export default CompleteOrderButton
